import styled from 'styled-components';

export const Container = styled.div`
  height: 82px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.hotelDetails.bookingInfo};
  padding-left: 22px;
  display: flex;
  width: 100%;
  font-size: 12px;
  align-items: center;
`;

export const BookingInfoTitle = styled.span`
  font-size: 12px;
  font-weight: bold;
`;

export const BookingInfoHeader = styled.div`
  font-family: Poppins;
  font-size: 12px;
  color: ${({ theme }) => theme.hotelDetails.roomTitleColor};
  display: flex;
`;

export const BookingInfoDates = styled.div`
  border-right-width: 1px;
  border-right-color: ${({ theme }) => theme.hotelDetails.bookingInfoDates};
  border-right-style: solid;
  font-weight: 600;
  font-size: 12px;
  padding-right: 16px;
`;

export const BookingInfoRoomsHeader = styled.span`
  display: table-cell;
  font-weight: 600;
  font-size: 12px;
`;

export const BookingInfoRoomsBody = styled.span`
  display: table-cell;
  font-weight: normal;
  font-size: 12px;
  display: block;
`;

export const BookingInfoRooms = styled.div`
  font-weight: normal;
  padding: 0 18px;
  font-size: 12px;
`;

export const BookingInfoCheckin = styled.span`
  width: 40%;
  float: left;
  font-size: 12px;
  font-weight: normal;
`;

export const BookingInfoCheckout = styled.span`
  text-align: right;
  width: 60%;
  float: left;
  font-size: 12px;
  font-weight: normal;
`;

export const EditContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  min-width: 18%;
  height: 100%;
  border-left: 2px solid ${({ theme }) => theme.hotelDetails.background};
`;

export const EditIcon = styled.img`
  flex-shrink: 0;
  font-size: 20px;
  margin: auto;
  cursor: pointer;
`;
